<template>
  <!-- front facing card -->
  <v-card
    tile
    class="pt--card-unrevealed fill-height"
    @click="
      if (proj.projSource) {
        return clickInsideTile();
      }
    "
    color="rgba(244, 219, 232, 0.57)"
  >
    <v-row class="align-center justify-center">
      <v-col>
        <v-card-text>
          <div class="pt--card-title">
            {{ proj.projTitle }}
          </div>
          <div class="pt--card-tag-container">
            <v-chip
              v-for="framework in proj.projFrameworks"
              :key="framework"
              x-small
              pill
              disabled
              class="ma-2"
              color="pink"
              text-color="white"
            >
              {{ framework }}
            </v-chip>
          </div>
        </v-card-text>
      </v-col>
    </v-row>
    <v-fade-transition hide-on-leave>
      <v-card
        v-click-outside="clickOutsideTile"
        v-if="reveal"
        class="pt--card-reveal"
        color="rgba(260, 200, 232)"
      >
        <!-- revealed card's short description -->
        <!-- <v-card-text class="pt--text-scroll">
          <p class="pt--text-style">
            {{ proj.projDes }}
          </p>
        </v-card-text> -->
        <!-- revealed card's actions -->
        <!-- <v-card-actions
          class="pt--card-actions d-flex"> -->
        <!-- <v-card-text class="d-flex align-content-center justify-center"> -->
        <v-row align="center" justify="center" class="text-center fill-height">
          <v-col cols="12">
            <v-btn
              v-if="proj.projSource"
              text
              class="accent-1"
              rounded
              outlined
              color="black"
              :href="proj.projSource"
              target="_blank"
            >
              Learn More
            </v-btn>
          </v-col>
        </v-row>
        <!-- </v-card-text> -->
        <!-- </v-card-actions> -->
      </v-card>
    </v-fade-transition>
  </v-card>
</template>

<script>
// import { mdiArrowTopRight } from '@mdi/js';
export default {
  name: "ProjectTile",
  data: () => ({
    reveal: false,
  }),
  props: ["proj"],
  methods: {
    clickOutsideTile() {
      this.reveal = false;
    },
    clickInsideTile() {
      this.reveal = !this.reveal;
    },
  },
};
</script>

<style scoped>
/* Project Tiles */
.pt--text-scroll {
  overflow-y: auto !important;
  overflow-x: hidden;
  height: 100%;
}

.pt--card-reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute !important;
  height: 100%;
  width: 100%;
  padding-bottom: 15%;
}

.pt--card-unrevealed {
  bottom: 0;
  position: relative;
  height: 100%;
  height: 20vh;
  max-height: 25vh;
  min-height: 20vh;
}

.pt--card-image {
  height: 10vh;
  aspect-ratio: 1;
}

.pt--card-actions {
  padding-top: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0;
  bottom: 0;
  height: 10%;
  position: absolute;
}

.pt--card-tag-container {
  bottom: 0;
  position: absolute;
}
</style>
